import {Component, Input, OnInit} from '@angular/core';
import {EvaluacionesSolicitudInterface} from "../../interfaces/evaluaciones.interface";
import {EvaluacionesService} from "../../services/evaluaciones.service";
import {DatePipe, Location, NgForOf} from "@angular/common";
import {Button, ButtonDirective} from "primeng/button";
import {PrimeTemplate} from "primeng/api";
import {TableModule} from "primeng/table";
import {TagModule} from "primeng/tag";
import {TooltipModule} from "primeng/tooltip";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-solicitud-evaluaciones',
  standalone: true,
    imports: [
        ButtonDirective,
        PrimeTemplate,
        TableModule,
        TagModule,
        TooltipModule,
        DatePipe,
        Button,
        RouterLink,
        NgForOf
    ],
  templateUrl: './solicitud-evaluaciones.component.html',
  styleUrl: './solicitud-evaluaciones.component.scss'
})
export class SolicitudEvaluacionesComponent implements OnInit{
    @Input("idSolicitud") idSolicitud: string | null = null
    cols: any [] = [];

  constructor(protected evaluacioneService:EvaluacionesService, private location: Location,) {
  }
    ngOnInit(): void {
      this.getEvaluacionesPorSolicitud(Number.parseInt(this.idSolicitud!));
    }
    private getEvaluacionesPorSolicitud(idSolicitud:number) {
        this.evaluacioneService.obtenerEvaluacionSolicitud(idSolicitud)
            .subscribe({
                next: (result) => {
                    if (result.status == 200) {
                        this.evaluacioneService._evaluacionesSolicitud.set(result.body!);
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }
    goBack(): void {
        this.location.back();
    }
    tagStyle(estado: boolean) {
        switch (estado) {
            case true:
                return {background: '#28a745'};
            case false:
                return {background: '#FF0000FF'};
            default:
                return {background: '#6c757d'};
        }
    }

    getUsuariosName(nombreUsuariosAsig: string): string[] {
        return nombreUsuariosAsig ? nombreUsuariosAsig.split(',').map(u => u.trim()) : [];
    }

}
